// Mapa iconName (string, ver notificationCatalog.ts) -> componente lucide-react. Separado del
// catálogo puro-de-datos porque este archivo sí importa JSX/React -- notificationCatalog.ts es
// también importado por server.ts, que no puede arrastrar React.
import {
  ShieldAlert, FileWarning, XCircle, AlertTriangle, AlertCircle, CheckCircle2, DollarSign,
  FileText, MessageSquare, Search, FileUp, Ban, Clock, PackagePlus, Bell, FileCheck,
  CalendarCheck, CalendarX, PackageX, AlertOctagon, FolderPlus, RefreshCw, MailWarning,
  type LucideIcon,
} from 'lucide-react';

export const NOTIFICATION_ICONS: Record<string, LucideIcon> = {
  ShieldAlert, FileWarning, XCircle, AlertTriangle, AlertCircle, CheckCircle2, DollarSign,
  FileText, MessageSquare, Search, FileUp, Ban, Clock, PackagePlus, Bell, FileCheck,
  CalendarCheck, CalendarX, PackageX, AlertOctagon, FolderPlus, RefreshCw, MailWarning,
};

export function getNotificationIcon(iconName: string): LucideIcon {
  return NOTIFICATION_ICONS[iconName] || Bell;
}

// Tailwind classes (soft background/text + dark variant) per catalog color token. Full literal
// object (no string interpolation) so the classes survive Tailwind's purge, which scans the
// source code for complete class names.
export const NOTIFICATION_COLOR_CLASSES: Record<string, { bg: string; text: string; ring: string }> = {
  rose: { bg: 'bg-rose-100 dark:bg-rose-500/15', text: 'text-rose-600 dark:text-rose-400', ring: 'ring-rose-200 dark:ring-rose-500/30' },
  amber: { bg: 'bg-amber-100 dark:bg-amber-500/15', text: 'text-amber-600 dark:text-amber-400', ring: 'ring-amber-200 dark:ring-amber-500/30' },
  emerald: { bg: 'bg-emerald-100 dark:bg-emerald-500/15', text: 'text-emerald-600 dark:text-emerald-400', ring: 'ring-emerald-200 dark:ring-emerald-500/30' },
  blue: { bg: 'bg-blue-100 dark:bg-blue-500/15', text: 'text-blue-600 dark:text-blue-400', ring: 'ring-blue-200 dark:ring-blue-500/30' },
  slate: { bg: 'bg-slate-100 dark:bg-slate-800', text: 'text-slate-500 dark:text-slate-400', ring: 'ring-slate-200 dark:ring-slate-700' },
};

export function getNotificationColorClasses(colorClass: string) {
  return NOTIFICATION_COLOR_CLASSES[colorClass] || NOTIFICATION_COLOR_CLASSES.slate;
}
